import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as components from './components'

@ngCore.Component({
  imports: [
    components.ruleSlideout.Component,
    ds.button.Component,
    ds.input.text.Component,
    ds.layout.page.Component,
    ds.overlay.confirmation.Component,
    ds.table.Component,
  ],
  selector: 'atn-rate-rules-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
// eslint-disable-next-line jsdoc/require-jsdoc
export class AtnRulesComponent {
  /**
   * NOTE: - Public due to the fact that it is being passed to the
   * {@link ds.table.Component atn-ds-table} component.
   *
   * Shortcut for {@link AtnRateEcService.ruleCollection}
   */
  public readonly ruleEc = ngCore.inject(state.rate.gl.rules.Collection)

  /** Canonical table input for the rules list. */
  public readonly tableConfig = {
    collection: this.ruleEc,
    view: {
      creation: create => this.creationRuleCallback(create),
      search: true,
      selection: true,
      title: 'Rules',
    },
  } satisfies ds.table.ec.Config.Input<state.rate.gl.rules.TypeParams>

  private readonly _applicationPlugin = this.ruleEc.plugins
    .lookup(state.rate.gl.rules.plugins.application.Plugin)
    .get()

  /* -------------------------------------------------------------------------- */
  /*                                  Handlers                                  */
  /* -------------------------------------------------------------------------- */

  /**
   * Initiates the update process of a {@link rule}
   */
  public ruleTableRowClickHandler(
    rule: Readonly.Deep<state.rate.gl.rules.Entity>,
  ): void {
    const source = `Table.Row-${rule.id}.Clicked`

    // TODO: editing plugin should be modified to make the below one action
    // (e.g. edit.from().dispatch({ id: rule.id, makeCurrent: { discardPrevious:
    // true } }))

    this.ruleEc.plugins.editingPlugin.feature.actions.discard
      .from(source)
      .dispatch({ current: true })

    this.ruleEc.plugins.editingPlugin.feature.actions.edit
      .from(source)
      .dispatch({ id: rule.id })
  }

  /** Initiates the creation of a {@link models.rate.GlMappingRule} */
  public creationRuleCallback = (
    create: (input: state.rate.gl.rules.CreateEntity) => void,
  ) => {
    create(ents.extra.rate.gl.Rule.Input.generate())
  }

  /**
   * Initiates the process of applying rules and preparing proposal
   */
  public applyRulesClickHandler(): void {
    this._applicationPlugin.feature.actions.apply
      .from('Table.Header.Buttons.ApplyRulesAndPrepareRateProposal.Clicked')
      .dispatch()
  }

  /* ------------------------- Slide-out(s) & dialogs ------------------------ */

  /**
   * Initiates the process of deleting a rule from a database
   *
   * NOTE: the deletion process is started by the
   * {@link AtnRateEcService.ruleCollection ruleCollection} table
   * {@link ds.table.ec.Plugin plugin} configuration.
   */
  public deleteRuleConfirmationOverlayBtnConfirmClickHandler() {
    this.ruleEc.plugins.editingPlugin.feature.actions.submit
      .from('DeleteOverlay.Button.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Discards the deletion of a rule
   *
   * NOTE: the deletion process is started by the
   * {@link AtnRateEcService.ruleCollection ruleCollection} table
   * {@link ds.table.ec.Plugin plugin} configuration.
   */
  public deleteRuleConfirmationOverlayBtnCancelClickHandler() {
    this.ruleEc.plugins.editingPlugin.feature.actions.discard
      .from('DeleteOverlay.Button.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
